let autocompleteB;
let autocompleteS;
let billingField;
let shippingField;
let billingpostalField;
let shippingpostalField;
let place;

/**
* Trova il campo per id esatto oppure per prefisso: in Modifica profilo gli id di provincia/città
* hanno in coda l'Id dell'indirizzo (es. reg-fprovincia123).
* Claude
* @param {string} id
* @returns {HTMLElement} elemento o null
*/
function GA_Elemento(id) {
    return document.getElementById(id) || document.querySelector('[id^="' + id + '"]:not([type="hidden"])');
}

/**
* Restituisce l'input su cui agganciare l'autocomplete di Google: il campo stesso se è un input,
* altrimenti l'input interno del widget DevExtreme.
* Claude
* @param {string} id
* @returns {HTMLInputElement} input o null
*/
function GA_Input(id) {
    var el = GA_Elemento(id);
    if (el && el.tagName !== 'INPUT') {
        el = el.querySelector('input.dx-texteditor-input') || el.querySelector('input');
    }
    return el && el.tagName === 'INPUT' ? el : null;
}

/**
* Restituisce l'istanza DevExtreme (TextBox/SelectBox) renderizzata nell'elemento, se presente.
* Claude
* @param {HTMLElement} el
*/
function GA_IstanzaDx(el) {
    if (!el || typeof DevExpress === 'undefined') {
        return null;
    }
    return DevExpress.ui.dxTextBox.getInstance(el) || DevExpress.ui.dxSelectBox.getInstance(el) || null;
}

/**
* Imposta il valore di un campo: sui widget DevExtreme passa da option('value') così il widget,
* i validatori e il POST vedono il dato; i widget disabilitati non vengono toccati.
* Claude
* @param {HTMLElement} el
* @param {string} valore
*/
function GA_ImpostaValore(el, valore) {
    if (!el) {
        return;
    }
    var istanza = GA_IstanzaDx(el);
    if (istanza) {
        if (!istanza.option('disabled')) {
            istanza.option('value', valore);
        }
        return;
    }
    el.value = valore;
}

/**
* Aggancia l'autocomplete di Google ai campi indirizzo presenti.
* Modificato da Claude: supporta i TextBox DevExtreme, salta i campi assenti (in Modifica profilo
* non c'è l'indirizzo di spedizione) e non aggancia due volte lo stesso input.
*/
function initAutocomplete() {
    if (typeof google === 'undefined' || !google.maps || !google.maps.places) {
        return;
    }

    var opt = {
        requestedLanguage: _cc,
        fields: ["address_components", "geometry"],
        types: ["address"]
    }

    if (_restriction.length > 0) {
        opt.componentRestrictions = { country: _restriction };
    }

    //Indirizzo di fatturazione
    var FInd = GA_Input("reg-findirizzo");
    if (FInd && !FInd.dataset.gautocomplete) {
        FInd.dataset.gautocomplete = '1';
        billingField = FInd;
        billingpostalField = GA_Elemento("reg-fcap");
        autocompleteB = new google.maps.places.Autocomplete(billingField, opt);
        autocompleteB.addListener("place_changed", function () { fillInAddress('f'); });
    }

    //Indirizzo di spedizione
    var SInd = GA_Input("reg-sindirizzo");
    if (SInd && !SInd.dataset.gautocomplete) {
        SInd.dataset.gautocomplete = '1';
        shippingField = SInd;
        shippingpostalField = GA_Elemento("reg-scap");
        autocompleteS = new google.maps.places.Autocomplete(shippingField, opt);
        autocompleteS.addListener("place_changed", function () { fillInAddress('s'); });
    }
}

function fillInAddress(t) {
    if (t === "f")
        place = autocompleteB.getPlace();
    else
        place = autocompleteS.getPlace();

    let address = "";
    let postcode = "";
    let citta = "";

    if (place) {
        // Get each component of the address from the place details,
        // and then fill-in the corresponding field on the form.
        // place.address_components are google.maps.GeocoderAddressComponent objects
        // which are documented at http://goo.gle/3l5i5Mr
        for (const component of place.address_components) {

            try {
                const componentType = component.types[0];
                switch (componentType) {
                    case "street_number": {
                        address = `${component.long_name} ${address}`;
                        break;
                    }
                    case "route": {
                        address = component.short_name + ', ' + address;
                        break;
                    }
                    case "postal_code": {
                        postcode = `${component.long_name}${postcode}`;
                        break;
                    }
                    case "postal_code_suffix": {
                        postcode = `${postcode}-${component.long_name}`;
                        break;
                    }
                    case "locality": {
                        citta = component.long_name;

                        var elCitta = GA_Elemento("reg-" + t + "citta");
                        if (elCitta != null) {
                            // SelectBox città (Spagna): solo il testo, il valore viene impostato dopo il reload per provincia
                            if (elCitta.tagName !== 'INPUT' && elCitta.querySelector("input") != null) {
                                elCitta.querySelector("input").value = component.long_name;
                            }
                            else {
                                elCitta.value = component.long_name;
                            }
                        }

                        break;
                    }
                    case "administrative_area_level_2": {
                        if (_lcid != 3079) {
                            GA_ImpostaValore(GA_Elemento("reg-" + t + "provincia"), component.short_name);

                            if (_lcid === "1034") {
                                var cittaSelectBox = GA_IstanzaDx(GA_Elemento("reg-" + t + "citta"));
                                if (cittaSelectBox) {
                                    cittaSelectBox.option('value', null);
                                    var selectBoxDataSource = cittaSelectBox.getDataSource();
                                    selectBoxDataSource.pageIndex(0);
                                    selectBoxDataSource.reload();
                                    cittaSelectBox.option('value', citta);
                                }
                            }
                        }

                        break;
                    }
                    case "country":
                        GA_ImpostaValore(GA_Elemento("reg-" + t + "nazione"), component.short_name);
                        break;
                }
            } catch (e) {
                console.log(e);
            }
        }

        /* Autore: Claude - non sovrascrivere mai con valore vuoto.
           Se la place selezionata non ha route/street_number (l'utente sceglie dal dropdown una
           localita' invece di un indirizzo civico) address resta "" e il campo via veniva svuotato,
           mentre CAP/citta'/provincia venivano riempiti. Con place_changed che arriva tra la
           validazione e l'invio della form, il POST partiva con l'indirizzo vuoto e la
           registrazione falliva lato server (5 utenti orfani tra 11/08 e 15/09/2026). */
        // Claude - i valori passano da GA_ImpostaValore sul contenitore, così funziona anche con i TextBox DevExtreme
        if (address) {
            GA_ImpostaValore(GA_Elemento("reg-" + t + "indirizzo"), address);
        }
        if (postcode) {
            GA_ImpostaValore(t === "f" ? billingpostalField : shippingpostalField, postcode);
        }
    }
}
